import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../service/common.service';
import { environment } from 'src/environments/environment';
import { ProjectSeoService } from 'src/app/services/projectseo.service';
import { ApicallService } from 'src/app/services/apicall.service';
@Component({
  selector: 'app-our-presence',
  templateUrl: './our-presence.component.html',
  styleUrls: ['./our-presence.component.css']
})
export class OurPresenceComponent implements OnInit{
  headerTitle = "Preschool In Agartala"
  all_data_list:any=[];
  cityList:any=[];
  constructor(private router: Router,private ngxSpinner:NgxSpinnerService,private _service: CommonService,
    private projectService: ProjectSeoService,private apiService: ApicallService)
  { }

  ngOnInit():void{
    this.getseo();
    this.getAllDataList();
  } 
  getseo() {
    let tbody = {
      slug: 'our-presence',
      Projectid: environment.projectid,
    };
    this.apiService.getGetseo(tbody).subscribe((data: any) => {
      this.projectService.sendMessageblog(data?.data?.blog);
      this.projectService.sendMessageseo(data?.data?.testimony);
      this.projectService.sendMessageFaqs(data?.data?.faq);
      this.projectService.setmeta(data?.data);
    });
  }

  goTocity(val: any) {
    this.router.navigateByUrl(`best-preschool-in-${val}`)
  }

  getAllDataList() {
    this.ngxSpinner.show();
    this._service.get_allCountryList().subscribe(
      res => {
        this.ngxSpinner.hide();
        this.all_data_list = res;
        localStorage.setItem('List',JSON.stringify(res));
        this.getcenter('A');
      }
    )
  }
  getcenter(char:string){
    this.cityList=[];
    let data=this.all_data_list.filter((dt:any)=>{
      return dt.City_Name.startsWith(char);
    });
    //const unique = [...new Set(data.map((data:any) => data.City_Name))];
      
    const group = data.reduce((acc: any, curr:any) => {
      let key = curr.City_Name;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(curr);
      return acc;
    }, {});
  
    let dt = Object.keys(group ).map(key => ({
      city: key,
      citycount: group[key].length
    }));
    this.cityList = dt.sort((a, b) => b.citycount - a.citycount);
  }

}
